// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results-page {
    display: flex;
    height: 100vh;
}

.left-section,
.right-section {
    width: 25%;
    align-items: center;
}

.left-section {
    border-right: 1px solid #ccc;
}

.right-section {
    border-left: 1px solid #ccc;
}

.middle-section {
    flex: 1 1;
    margin: 0 10px;
    background-color: #f9f9f9;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    text-align: center;
    overflow-y: auto; /* Dikey scroll ekledik */
}

.question-box {
    background-color: #e6e6e6;
    border: 1px solid #3c4f58;
    border-radius: 8px;
    padding: 15px;
    margin: 20px auto;
    font-weight: 300;
    text-align: left;
    color: #3c4f58;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    display: block;
    word-wrap: break-word;
    max-width: 95%;
}

.message-box {
    background-color: #fff;
    border-radius: 8px;
    padding: 0px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-width: 95%;
    margin: 20px auto;
    text-align: left;
    overflow-y: auto;
    min-height: 71vh; /* Daha esnek bir yükseklik */
    max-height: calc(4500vh - 90px); /* Küçük ekranlar için uyumlu hale getirme */
    display: flex;
    flex-direction: column;
    position: relative;
}


.message-content {
    width: 90%;
    height: 100%;
    flex-grow: 1;

}

.message-box p {
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 1em;
    color: #333;
    text-align: justify;
}

.markdown-content {
    position: relative; /* İçerik için de relative */
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    padding: 5px;
}

/* İlk paragraf (Giriş başlığı) için özel stil */
.markdown-content p:first-of-type {
    font-weight: bold;
    font-size: 1.2em;
    position: relative;
    top: 0; /* Message box'ın üstüne hizala */
    margin: 0; /* Margin'i sıfırla */
}

.markdown-content strong {
    font-weight: 600;
    color: #1a1a1a;
}

.markdown-content h1,
.markdown-content h2 {
    font-size: 1.5em;
    margin: 1.2em 0 0.8em;
    color: #1a1a1a;
    font-weight: 600;
}

.markdown-content sup {
    color: #61879c;
    font-size: 0.8em;
    margin: 0 2px;
}

.markdown-content ul,
.markdown-content ol {
    margin-left: 1.5em;
    margin-bottom: 1em;
}

.markdown-content li {
    margin-bottom: 0.5em;
}

/* İkonlar için stiller */
.download-icon-container {
    display: flex;
    justify-content: center;
    padding: 10px;
    background-color: #f0f0f0;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    width: 20%;
    margin-left: auto;
    margin-right: 20px;
    border: 1px solid #ccc;

    /*margin:0 auto;*/ /* Ortalamak için OPSİYONEL */

}

.icon-button,
.download-button {

        background-color: transparent;
        border: none;
        cursor: pointer;
        color: #3c4f58;
        transition: all 0.2s ease;
        padding: 8px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;

}

.icon-button:hover,
.download-button:hover {
    background-color: #e0e0e0;
    color: #1fbd93;
    transform: translateY(-1px);
}


.reference-citation {
    display: inline-block;
    color: #2563eb;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.2s ease;
    padding: 2px 4px;
}

.reference-citation:hover {
    background-color: rgba(37, 99, 235, 0.1);
}

.reference-citation sup {
    font-weight: 500;
}

/* RightTabs'teki highlight efekti için */
.reference-item.highlighted {
    background-color: rgba(37, 99, 235, 0.1);
    border-left: 4px solid #2563eb;
    transition: all 0.3s ease;
}
.bottom-controls-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    padding: 10px;
    margin-top: 10px;
    width: 100%;
}

.action-buttons-container {
    display: flex;
    gap: 10px;
    background-color: #f0f0f0;
    padding: 8px 12px;
    border-radius: 8px;
    height: fit-content;
}


/* İki container'ı yan yana koymak için kapsayıcı div */
.controls-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 50px;
    width: 100%;
}

/* Search bar container stilleri */
.search-bar-container {
    display: flex;
    justify-content: center;
    width: 100%;
}

.results-page .searchbar-container {
    display: flex;
    border-radius: 8px;
    transition: all 0.3s ease;
    box-sizing: border-box;

}

/* Focus durumunda genişleme efekti */
.results-page .searchbar-container.focused {
    width: 200%;
}

.results-page .search-input {
    width: 100%;
    border: none; /* Sınır rengi */
    background: transparent;
    transition: all 0.3s ease;
    height: 56px; /* Yüksekliği ayarlıyoruz */
    padding: 0 85px 0 20px; /* Soldan ve sağdan iç boşluklar */
    border: 2px solid #3c4f58; /* Sınır rengi */
    border-radius: 8px;
    font-size: 16px;
    box-sizing: border-box;
}

.results-page .search-input:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgb(0, 60, 79);}

.results-page .search-icons {
    position: absolute;
    right: 15px;
    top: 50%;
    display: flex;
    gap: 15px;
    align-items: center;
}

.results-page .slider-icon,
.results-page .search-icon {
    color: #3c4f58;
    cursor: pointer;
    font-size: 18px;
    transition: color 0.2s ease;
}

`, "",{"version":3,"sources":["webpack://./src/pages/ResultPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;;IAEI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,SAAO;IACP,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB,EAAE,yBAAyB;AAC/C;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,cAAc;IACd,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB,EAAE,6BAA6B;IAC/C,+BAA+B,EAAE,4CAA4C;IAC7E,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;;AAGA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;;AAEhB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB,EAAE,4BAA4B;IAChD,8EAA8E;IAC9E,YAAY;AAChB;;AAEA,gDAAgD;AAChD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,MAAM,EAAE,iCAAiC;IACzC,SAAS,EAAE,qBAAqB;AACpC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;;IAEtB,iBAAiB,EAAE,6BAA6B;;AAEpD;;AAEA;;;QAGQ,6BAA6B;QAC7B,YAAY;QACZ,eAAe;QACf,cAAc;QACd,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;;AAE/B;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;IACd,2BAA2B;AAC/B;;;AAGA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;AACpB;;AAEA,yCAAyC;AACzC;IACI,wCAAwC;IACxC,8BAA8B;IAC9B,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;;AAGA,uDAAuD;AACvD;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;;AAE1B;;AAEA,qCAAqC;AACrC;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY,EAGe,gBAAgB;IAC3C,uBAAuB;IACvB,yBAAyB;IACzB,YAAY,EAAE,2BAA2B;IACzC,sBAAsB,EAAE,kCAAkC;IAC1D,yBAAyB,EAAE,gBAAgB;IAC3C,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,oCAAoC,CAAC;;AAEzC;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B","sourcesContent":[".results-page {\r\n    display: flex;\r\n    height: 100vh;\r\n}\r\n\r\n.left-section,\r\n.right-section {\r\n    width: 25%;\r\n    align-items: center;\r\n}\r\n\r\n.left-section {\r\n    border-right: 1px solid #ccc;\r\n}\r\n\r\n.right-section {\r\n    border-left: 1px solid #ccc;\r\n}\r\n\r\n.middle-section {\r\n    flex: 1;\r\n    margin: 0 10px;\r\n    background-color: #f9f9f9;\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n    text-align: center;\r\n    overflow-y: auto; /* Dikey scroll ekledik */\r\n}\r\n\r\n.question-box {\r\n    background-color: #e6e6e6;\r\n    border: 1px solid #3c4f58;\r\n    border-radius: 8px;\r\n    padding: 15px;\r\n    margin: 20px auto;\r\n    font-weight: 300;\r\n    text-align: left;\r\n    color: #3c4f58;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n    display: block;\r\n    word-wrap: break-word;\r\n    max-width: 95%;\r\n}\r\n\r\n.message-box {\r\n    background-color: #fff;\r\n    border-radius: 8px;\r\n    padding: 0px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    max-width: 95%;\r\n    margin: 20px auto;\r\n    text-align: left;\r\n    overflow-y: auto;\r\n    min-height: 71vh; /* Daha esnek bir yükseklik */\r\n    max-height: calc(4500vh - 90px); /* Küçük ekranlar için uyumlu hale getirme */\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n}\r\n\r\n\r\n.message-content {\r\n    width: 90%;\r\n    height: 100%;\r\n    flex-grow: 1;\r\n\r\n}\r\n\r\n.message-box p {\r\n    font-size: 16px;\r\n    line-height: 1.6;\r\n    margin-bottom: 1em;\r\n    color: #333;\r\n    text-align: justify;\r\n}\r\n\r\n.markdown-content {\r\n    position: relative; /* İçerik için de relative */\r\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\r\n    padding: 5px;\r\n}\r\n\r\n/* İlk paragraf (Giriş başlığı) için özel stil */\r\n.markdown-content p:first-of-type {\r\n    font-weight: bold;\r\n    font-size: 1.2em;\r\n    position: relative;\r\n    top: 0; /* Message box'ın üstüne hizala */\r\n    margin: 0; /* Margin'i sıfırla */\r\n}\r\n\r\n.markdown-content strong {\r\n    font-weight: 600;\r\n    color: #1a1a1a;\r\n}\r\n\r\n.markdown-content h1,\r\n.markdown-content h2 {\r\n    font-size: 1.5em;\r\n    margin: 1.2em 0 0.8em;\r\n    color: #1a1a1a;\r\n    font-weight: 600;\r\n}\r\n\r\n.markdown-content sup {\r\n    color: #61879c;\r\n    font-size: 0.8em;\r\n    margin: 0 2px;\r\n}\r\n\r\n.markdown-content ul,\r\n.markdown-content ol {\r\n    margin-left: 1.5em;\r\n    margin-bottom: 1em;\r\n}\r\n\r\n.markdown-content li {\r\n    margin-bottom: 0.5em;\r\n}\r\n\r\n/* İkonlar için stiller */\r\n.download-icon-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 10px;\r\n    background-color: #f0f0f0;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n    width: 20%;\r\n    margin-left: auto;\r\n    margin-right: 20px;\r\n    border: 1px solid #ccc;\r\n\r\n    /*margin:0 auto;*/ /* Ortalamak için OPSİYONEL */\r\n\r\n}\r\n\r\n.icon-button,\r\n.download-button {\r\n\r\n        background-color: transparent;\r\n        border: none;\r\n        cursor: pointer;\r\n        color: #3c4f58;\r\n        transition: all 0.2s ease;\r\n        padding: 8px;\r\n        border-radius: 4px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n}\r\n\r\n.icon-button:hover,\r\n.download-button:hover {\r\n    background-color: #e0e0e0;\r\n    color: #1fbd93;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n\r\n.reference-citation {\r\n    display: inline-block;\r\n    color: #2563eb;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    transition: all 0.2s ease;\r\n    padding: 2px 4px;\r\n}\r\n\r\n.reference-citation:hover {\r\n    background-color: rgba(37, 99, 235, 0.1);\r\n}\r\n\r\n.reference-citation sup {\r\n    font-weight: 500;\r\n}\r\n\r\n/* RightTabs'teki highlight efekti için */\r\n.reference-item.highlighted {\r\n    background-color: rgba(37, 99, 235, 0.1);\r\n    border-left: 4px solid #2563eb;\r\n    transition: all 0.3s ease;\r\n}\r\n.bottom-controls-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 15px;\r\n    padding: 10px;\r\n    margin-top: 10px;\r\n    width: 100%;\r\n}\r\n\r\n.action-buttons-container {\r\n    display: flex;\r\n    gap: 10px;\r\n    background-color: #f0f0f0;\r\n    padding: 8px 12px;\r\n    border-radius: 8px;\r\n    height: fit-content;\r\n}\r\n\r\n\r\n/* İki container'ı yan yana koymak için kapsayıcı div */\r\n.controls-wrapper {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    margin-top: 50px;\r\n    width: 100%;\r\n}\r\n\r\n/* Search bar container stilleri */\r\n.search-bar-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 100%;\r\n}\r\n\r\n.results-page .searchbar-container {\r\n    display: flex;\r\n    border-radius: 8px;\r\n    transition: all 0.3s ease;\r\n    box-sizing: border-box;\r\n\r\n}\r\n\r\n/* Focus durumunda genişleme efekti */\r\n.results-page .searchbar-container.focused {\r\n    width: 200%;\r\n}\r\n\r\n.results-page .search-input {\r\n    width: 100%;\r\n    border: none;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    border: 2px solid #3c4f58; /* Sınır rengi */\r\n    background: transparent;\r\n    transition: all 0.3s ease;\r\n    height: 56px; /* Yüksekliği ayarlıyoruz */\r\n    padding: 0 85px 0 20px; /* Soldan ve sağdan iç boşluklar */\r\n    border: 2px solid #3c4f58; /* Sınır rengi */\r\n    border-radius: 8px;\r\n    font-size: 16px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.results-page .search-input:focus {\r\n    outline: none;\r\n    box-shadow: 0 0 0 2px rgb(0, 60, 79);}\r\n\r\n.results-page .search-icons {\r\n    position: absolute;\r\n    right: 15px;\r\n    top: 50%;\r\n    display: flex;\r\n    gap: 15px;\r\n    align-items: center;\r\n}\r\n\r\n.results-page .slider-icon,\r\n.results-page .search-icon {\r\n    color: #3c4f58;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n    transition: color 0.2s ease;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
